import { UseFormReturn } from 'react-hook-form';

import { FormField, FormItem, FormMessage } from '@@/ui/primitives';
import { Field } from '../../../../schemas/entity';
import { CreateItemPayload } from '../../../../schemas/item';
import { YamlInput } from '../../../shared/field-inputs';

interface YamlFieldRendererProps {
  fieldKey: string;
  field: Field;
  form: UseFormReturn<CreateItemPayload['attributes']>;
  label: string;
  disabled?: boolean;
}

export function YamlFieldRenderer({ fieldKey, field, form, label, disabled = false }: YamlFieldRendererProps) {
  const definition = field.definition;

  if (definition.type !== 'yaml') {
    return null;
  }

  return (
    <FormField
      control={form.control}
      name={fieldKey}
      render={({ field: formField }) => (
        <FormItem>
          <YamlInput
            value={formField.value || ''}
            onChange={formField.onChange}
            label={label}
            placeholder={`Enter ${fieldKey}...`}
            disabled={disabled}
            height='500px'
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
